// extracted by mini-css-extract-plugin
export default {"container":"ExhibitDetail_container__md874","icon":"ExhibitDetail_icon__-pSI6","title":"ExhibitDetail_title__9jQlT"};